import { isKeyedAggregation } from '@/explore/pipeline/operation';
import { FieldOrGroup } from '@/explore/pipeline/utils';
import { Aggregation } from '@/explore/types';
import { isNil } from '@/lib/utils';

import { isValidCondition } from './filter';

export const isValidAggregation = (aggregation: Aggregation, fields: FieldOrGroup[]): boolean => {
  if (isNil(aggregation.property.name)) {
    return false;
  }
  if (isKeyedAggregation(aggregation)) {
    if (isNil(aggregation.property.name) || isNil(aggregation.key)) {
      return false;
    }
  }
  const filter = 'filter' in aggregation ? aggregation.filter : undefined;
  if (filter && !isValidCondition(filter, fields)) {
    return false;
  }
  return true;
};
